<template>
  <Breadcrumbs
      title="View Promotion"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
      { label: 'View Promotion', path: `/view-promotion?promoId=${promoId}&isApplied=${isApplied}` }
    ]"
  />


  <div class="container-fluid">
    <div class="row project-cards">
      <!-- Pass promoId prop to form -->
      <viewPromotionForm
        :promoId="promoId"
        :isApplied="isApplied"
      />
    </div>
  </div>
</template>

<script>
import viewPromotionForm from './view_promotion_form.vue'

export default {
  name: 'viewPromotion',
  components: {
    viewPromotionForm,
  },
  computed: {
    promoId() {
      return this.$route.query.promoId; // read query param
    },
    isApplied() {
      return this.$route.query.isApplied === "true"; // ✅ ensure boolean
    }
  }
}
</script>
